module.exports = __webpack_public_path__ + "img/yingxiao02.71d14560.png";